import { Checkbox, Col, ReactSelectBox, Row, SwitchToggle, Tooltip } from 'client/CommonComponents'
import './PurchaseDetail.scss'
import PODetailGrid from '../PODetailGrid'
import { useMemo } from 'react';
import CancelConfirmationPopup from 'client/CommonComponents/DialogBox/CancelConfirmationPopup';
import { CONSTANTS } from 'client/utils/constants';

interface IProps {
    purchaseOrderStepperData: any,
    handleOnChange: any,
    setIsButtondisable: any,
    activeStepper?: any,
    id?: any,
    Popupcontent?: any,
    hideDialog?: any
}

const PurchaseDetail = ({
    purchaseOrderStepperData,
    handleOnChange,
    setIsButtondisable,
    activeStepper,
    id,
    Popupcontent,
    hideDialog
}:IProps) => {
    const descriptionValue = useMemo(() => {
        return purchaseOrderStepperData?.descriptionDropdownList?.find(
          (x: any) => x.label === purchaseOrderStepperData?.purchaseDetails?.description
        );
      }, [purchaseOrderStepperData?.equipmentSpecification, purchaseOrderStepperData?.descriptionDropdownList]);

    return(
       <div className='purchasedetail-container'>
            <Row>
                <Col xs={12} sm={12} md={12} lg={4} xl={4} className='mb-2'>
                <div onClick={(e: any) => {e.preventDefault()}}>    
                <Tooltip content={descriptionValue?.label || ''} data-attribute="PurchaseDetail_Default_Tooltip_16">
                    <ReactSelectBox
                        name={'description'}
                        options={purchaseOrderStepperData?.descriptionDropdownList}
                        isSearchable={true}
                        placeholder='Description'
                        value={descriptionValue}
                        isDisabled = {purchaseOrderStepperData?.isPOCreated || purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED)}
                        onChange={(item:any)=>{handleOnChange('description', item.description,item)}}
                     data-attribute="PurchaseDetail_description_SearchSelectBox" />
                </Tooltip>  
                </div>  
                </Col>
                {purchaseOrderStepperData?.purchaseDetails?.items?.length > 1 ?
                <Col xs={12} sm={12} md={8} lg={6} xl={4} className='mb-2 checkbox-consolidatepo'>
                    <Checkbox
                        title='createUniquePo'
                        checked={!!purchaseOrderStepperData?.purchaseDetails?.createUniquePo}
                        onChange={(item:any)=>handleOnChange(item.target.title, item.target.checked)}
                        disabled = { purchaseOrderStepperData?.isPOCreated || purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED) }
                     data-attribute="PurchaseDetail_createUniquePo_Checkbox" />
                    <span><b>Create Consolidated PO</b>{ purchaseOrderStepperData?.isPOCreated ? `(Option not available - PO's have been created)` : null }</span>
                </Col>
                : null}
                <Col xs={12} sm={12} md={4} lg={2} xl={4} className='mb-2 switchtoggle-block'>
                    <span>Licensed/Title</span>
                    <SwitchToggle
                        name='isLicensedTitled'
                        checked={!!purchaseOrderStepperData?.purchaseDetails?.isLicensedTitled}
                        onChange={(item:any, value:any)=>handleOnChange('isLicensedTitled', value)}
                        disabled = {purchaseOrderStepperData?.isPOCreated || purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED)}
                     data-attribute="PurchaseDetail_isLicensedTitled_SwitchToggle" />
                </Col>
            </Row>
            <PODetailGrid id = {id} isDisplayInPopUp = {false} activeStepper = {activeStepper} purchaseDetailsItem = {purchaseOrderStepperData?.purchaseDetails?.items} purchaseOrderStepperData={purchaseOrderStepperData} setIsButtondisable={setIsButtondisable}/>
            <CancelConfirmationPopup
                hideDialog={!Popupcontent.isDialogVisible}
                onDismiss={hideDialog}
                Popupcontent={Popupcontent}
                popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
                popupPrimarybtnOnclick={() => Popupcontent?.popupPrimarybtnOnclick()}
            />
       </div>
    )
}

export default PurchaseDetail